export var TEXT_INPUT_CLASS_PREFIX = 'TextInput';
export var textInputRoot = 'TextInputRoot';
export var textInputInput = 'TextInputInput';
export var textInputLabel = 'TextInputLabel';
export var textInputLabelBackground = 'TextInputLabelBackground';